module.exports = __webpack_public_path__ + "img/Puente_Istobal_MSTART_Alto_Blanco-default-back.41f2419a.jpg";